import { availabilitiesApi } from './index'

export default availabilitiesApi.middleware
